export default function (offer) {
  // Offer can only be added to cart if it has a redeem message in the store
  return offer.redeemMessageInStore != null
}
